"use client";
import { rpc } from "#rpc";
import { useTranslations } from "@/i18n/client";
import { useToken } from "@frend-digital/centra/client";
import { useQuery } from "@tanstack/react-query";
import { Suspense } from "react";
import ProductCard from "../ProductCard";
import styles from "./index.module.css";

import type { ProductCard as ProductCardType } from "@/lib/centra/formatters";
export const StyleWithProducts = ({
  productIds,
}: {
  productIds: (string | undefined)[];
}) => {
  const token = useToken();
  const { data: products } = useQuery({
    queryKey: ["depict-style-with", productIds],
    queryFn: async () => {
      const products = await rpc.depict.recommendations({
        product_ids: productIds,
        type: "cross_sell",
        limit: 4,
        token: token!,
      });

      return products;
    },
    enabled: !!productIds.length && !!token,
  });

  if (!products || products.length === 0) return null;

  return (
    <div className={styles.relatedProducts}>
      <Suspense fallback>
        <UnsuspendedRelatedProducts products={products} />
      </Suspense>
    </div>
  );
};

const UnsuspendedRelatedProducts = ({
  products,
}: {
  products: (ProductCardType | undefined)[];
}) => {
  const t = useTranslations();

  return (
    <>
      <div data-layout="page" className={styles.title}>
        <h2>{t("products.style_with")}</h2>
      </div>
      <div data-layout="page" className={styles.relatedProductsGrid}>
        {products?.map((product) => {
          return (
            <ProductCard
              related
              key={product?.displayItemId}
              product={product!}
            />
          );
        })}
      </div>
    </>
  );
};
export default StyleWithProducts;
